import { render, staticRenderFns } from "./CookieDialog.vue?vue&type=template&id=5e6139c3&scoped=true"
import script from "./CookieDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CookieDialog.vue?vue&type=style&index=0&id=5e6139c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6139c3",
  null
  
)

export default component.exports